import {
  Button,
  CancelButton,
  LocationConfig,
  LoginWizardContainer,
  useStartProviderAuthIntent,
  type WizardComponent,
} from '@unipile/ui';
import { useTranslation } from 'react-i18next';

export const Wizard: WizardComponent = ({ onSuccess, onError, onCancel }) => {
  const mutation = useStartProviderAuthIntent({
    mutationConfig: {
      onSuccess: (response) => {
        if (response.object === 'OauthUrl') onSuccess(response);
        console.warn('This code should not be reachable');
      },
      onError,
    },
  });

  const { t } = useTranslation();

  const handleClick = () => {
    mutation.mutate({
      data: {
        provider: 'outlook',
        oauth_callback_redirect_uri: '', // This is automatically set to the redirect_uri in the Hosted Auth Token by the useConnectAccount hook
      },
    });
  };

  return (
    <LoginWizardContainer>
      <Button disabled={mutation.isPending} className="w-full" variant="outline" onClick={handleClick}>
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" className="mr-2 size-4">
          <rect x="1" y="1" width="9" height="9" fill="#f25022" />
          <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
          <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
          <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
        </svg>
        {t('Button', { ns: 'outlook' })}
      </Button>
      <LocationConfig provider="outlook" className="mt-4" />
      <CancelButton onCancel={onCancel} />
    </LoginWizardContainer>
  );
};
